(function initHeaderBottom() {
  if (!document.querySelector('nav.stick-nav')) return;

  const headerSection = document.querySelector('.header-section');
  if (!headerSection) return;

  let lastBottom = -1;
  /** @type {number | null} */
  let rafId = null;

  const updateHeaderBottom = () => {
    const bottom = Math.round(headerSection.getBoundingClientRect().bottom);

    if (bottom === lastBottom) return;

    lastBottom = bottom;
    document.documentElement.style.setProperty('--header-bottom', `${bottom}px`);
  };

  const scheduleUpdate = () => {
    if (rafId !== null) return;

    rafId = requestAnimationFrame(() => {
      rafId = null;
      updateHeaderBottom();
    });
  };

  updateHeaderBottom();
  new ResizeObserver(scheduleUpdate).observe(headerSection);
  document.addEventListener('scroll', scheduleUpdate, { passive: true });
})();
